import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {PoActivityOverviewRoutingModule} from './po-activity-overview-routing.module';
import {NewOrderDialogComponent, PoActivityOverviewComponent} from './po-activity-overview.component';

import {FlexLayoutModule} from '@angular/flex-layout';
import {LayoutModule} from '@angular/cdk/layout';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {TranslateModule} from '@ngx-translate/core';
import {NgxPermissionsModule} from 'ngx-permissions';

@NgModule({
    declarations: [PoActivityOverviewComponent, NewOrderDialogComponent],
    imports: [
        CommonModule,
        HttpClientModule,
        PoActivityOverviewRoutingModule,
        FlexLayoutModule,
        LayoutModule,

        /* Angular material */
        MatButtonModule,
        MatIconModule,
        MatListModule,
        MatGridListModule,
        MatCardModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        TranslateModule,
        NgxPermissionsModule
    ],
    exports: [PoActivityOverviewComponent]
})
export class PoActivityOverviewModule {
}
